import { CommonModule } from '@angular/common'
import { AfterViewInit, Component, OnDestroy } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MatTooltipModule } from '@angular/material/tooltip'
import { BricksIconComponent } from '@enbw_bricks/ui'

@Component({
  selector: 'app-scroll-top-button',
  templateUrl: './scroll-top-button.component.html',
  styleUrls: ['./scroll-top-button.component.scss'],
  imports: [CommonModule, MatButtonModule, BricksIconComponent, MatTooltipModule],
  standalone: true,
})
export class ScrollTopButtonComponent implements AfterViewInit, OnDestroy {
  showScrollTopButton = false

  private scrollTarget: HTMLElement | null = null
  private retryTimer: ReturnType<typeof setTimeout> | null = null

  private readonly onScroll = () => {
    this.showScrollTopButton = (this.scrollTarget?.scrollTop ?? 0) > 400
  }

  ngAfterViewInit(): void {
    this.scrollTarget =
      Array.from(globalThis.document.querySelectorAll<HTMLElement>('.content-area')).find(
        (target) => target.scrollHeight > target.clientHeight
      ) ?? null

    this.scrollTarget?.addEventListener('scroll', this.onScroll, { passive: true })
    this.onScroll()
  }

  ngOnDestroy(): void {
    this.scrollTarget?.removeEventListener('scroll', this.onScroll)

    if (this.retryTimer) {
      globalThis.clearTimeout(this.retryTimer)
    }
  }

  scrollToTop(): void {
    this.scrollTarget?.scrollTo({ top: 0, behavior: 'smooth' })
  }

  private bindScrollTarget(): void {
    const target = this.findScrollTarget()

    if (!target) {
      this.retryTimer = globalThis.setTimeout(() => this.bindScrollTarget(), 100)
      return
    }

    this.scrollTarget?.removeEventListener('scroll', this.onScroll)
    this.scrollTarget = target
    this.scrollTarget.addEventListener('scroll', this.onScroll, { passive: true })
    this.onScroll()
  }

  private findScrollTarget(): HTMLElement | null {
    const targets = Array.from(globalThis.document.querySelectorAll<HTMLElement>('.content-area'))

    return targets.find((target) => target.scrollHeight > target.clientHeight) ?? null
  }
}
